import { QueryClient } from '@tanstack/react-query';

// QueryClient konfiqurasiyası
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 dəqiqə - data 5 dəqiqə "fresh" sayılır
      gcTime: 10 * 60 * 1000, // 10 dəqiqə - cache-də qalır (əvvəl cacheTime idi)
      refetchOnWindowFocus: false, // Window focus olduqda refetch etmə
      refetchOnMount: true, // Component mount olduqda refetch et
      refetchOnReconnect: true, // İnternet yenidən qoşulduqda refetch et
      retry: 1, // 1 dəfə retry et
      retryDelay: 1000, // 1 saniyə gözlə
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
});

